import React from 'react';
import { FaPlane, FaWater } from 'react-icons/fa';


/**
 * @component
 * @category Search Page
 * @subcategory Search bar
 * @name DropdownItems
 * @description It's the single dropdown item of different modes in 'type of shipment', which is present beside date picker/calender.
 * <br> <br>
 * **Example**
 * ```js
 *  const data = {name: 'FCL', desc: 'FULL CONTAINER LOAD'};
 *  <DropdownItems data={data} />
 * ```
 * @param {Object} props - Component props
 * @param {Object} props.data - It has info about single dropdown item
 * @param {string} props.data.name - name of the item
 * @param {string} props.data.desc - description of the item
 */
const DropdownItems = ({ data }) => {
  return (
    <div style={{ width: '100%', height: '53px' }} className="testR1">
      <div>
        <span
          style={{ fontSize: '8px', padding: '5px 0px 0px 0px' }}
          className="testR1"
        >
          {data.desc}
        </span>
      </div>
      <div style={{ padding: '2px 5px 8px 14px' }} className="testR1">
        {data.name === 'AIR' ? <FaPlane /> : <FaWater />}
        <span
          style={{ display: 'inline', marginLeft: '10px', fontSize: '18px' }}
        >
          {data.name}
        </span>
      </div>
    </div>
  );
};

export default DropdownItems;
